import React from 'react';

import { LoaderBlock } from 'src/app/components/Loader/LoaderBlock';
import { withStyles } from 'src/app/helpers/styles';

@withStyles(require('./LoaderPage.scss'))
export class LoaderPage extends React.Component {
  render(): JSX.Element {
    return (
      <section className="loader-page position-fixed top-0 bottom-0 left-0 right-0">
        <LoaderBlock blocking={true} className="loader-page__loader-block" />
      </section>
    );
  }
}
